module.exports = __webpack_public_path__ + "media/images/vTAK_ShieldLogoAlpha-71c8a9b09d63bf3ec5cf75a6da8bdce2.png";